module.exports = __webpack_public_path__ + "media/images/webpage/hotels/895/room-d7508d7c56431df669a455ff1914fc7a.webp";